import Vue from 'vue'
import axios from 'axios'
import Cookies from 'js-cookie'

import {
  ACTION_LOGIN,
  ACTION_LOGOUT,
} from '@/store/actions'

import {
  ACTION_GET_USER,
  ACTION_GET_NOTIFICATION,
} from '../actions'

import {
  MUTATION_SET_USER,
  MUTATION_SET_IS_AUTHENTICATED,
  MUTATION_SET_USER_TOKEN,
  MUTATION_SET_NOTIFICATION,
} from '../mutations'

import masterApiCall from '../../utils/api'

const changeAxiosAuthorzationHeader = (token) => {
  axios.defaults.headers.common.Authorization = token && token.length > 0
    ? `Bearer ${token}`
    : ''
}

const userModule = {
  state: {
    user: {
      id: -1,
      kind: '',
    },

    isAuthenticated: false,
    token: '',

    notification: {
      nApplications: 0,
    },
  },

  mutations: {
    [MUTATION_SET_USER](state, {
      id,
      kind,
      name,
      email,
      group,
    }) {
      Vue.set(state, 'user', {
        id,
        kind,
        name,
        email,
        group,
      })
    },

    [MUTATION_SET_IS_AUTHENTICATED](state, value) {
      Vue.set(state, 'isAuthenticated', value)
    },

    [MUTATION_SET_USER_TOKEN](state, token) {
      changeAxiosAuthorzationHeader(token)
      Vue.set(state, 'token', token)
    },

    [MUTATION_SET_NOTIFICATION](state, notification) {
      Vue.set(state, 'notification', notification)
    },
  },

  actions: {
    [ACTION_LOGIN]({ commit }, { user, token, isRemember }) {
      commit(MUTATION_SET_USER_TOKEN, token)

      commit(MUTATION_SET_USER, user)
      commit(MUTATION_SET_IS_AUTHENTICATED, true)

      if (isRemember) {
        Cookies.set('h_t', token, { expires: 3 })
      }
    },

    [ACTION_GET_USER]: async ({ commit }) => {
      const { data } = await masterApiCall('get', '/me')
      commit(MUTATION_SET_USER, data.user)
      commit(MUTATION_SET_USER_TOKEN, data.token)
      commit(MUTATION_SET_IS_AUTHENTICATED, true)
    },

    [ACTION_LOGOUT]({ commit }) {
      Cookies.remove('h_t')

      commit(MUTATION_SET_USER_TOKEN, '')
      commit(MUTATION_SET_IS_AUTHENTICATED, false)

      window.location.href = process.env.NODE_ENV === 'development'
        ? 'http://localhost:8300'
        : window.location.origin
    },

    [ACTION_GET_NOTIFICATION]({ commit }) {
      masterApiCall('get', '/masteradmin/notifications')
        .then(({ data: { count } }) => {
          commit(MUTATION_SET_NOTIFICATION, {
            nApplications: count,
          })
        })
    },
  },
}

export default userModule



// WEBPACK FOOTER //
// ./client/masteradmin/store/userModule/index.js